import React from 'react';
import { AlertTriangle, X, Trash2 } from 'lucide-react';

const DeleteClientModal = ({ selectedRows = [], onClose, onDelete }) => {
  const count = selectedRows.length;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
        {/* Top accent bar */}
        <div className="h-1.5 w-full bg-gradient-to-r from-red-400 via-red-500 to-red-600" />

        {/* Header */}
        <div className="flex items-start justify-between px-6 pt-6 pb-2">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0 w-11 h-11 rounded-full bg-red-50 flex items-center justify-center border border-red-100">
              <AlertTriangle size={22} className="text-red-500" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900 tracking-tight">
                Delete {count > 1 ? 'Clients' : 'Client'}
              </h2>
              <p className="text-xs text-gray-400 mt-0.5">This action cannot be undone</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          <div className="bg-red-50 border border-red-100 rounded-xl p-4">
            <p className="text-sm text-gray-700 leading-relaxed">
              You are about to permanently delete{' '}
              <span className="font-semibold text-red-600">
                {count} {count === 1 ? 'client' : 'clients'}
              </span>
              . All associated data including contacts, agreements, and activity history will be removed.
            </p>
          </div>

          <p className="text-xs text-gray-400 mt-3 text-center">
            Are you sure you want to continue?
          </p>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 px-6 py-4 bg-gray-50 border-t border-gray-100">
          <button
            onClick={onClose}
            className="px-5 py-2.5 text-sm font-medium text-gray-600 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 hover:border-gray-300 transition-all"
          >
            Cancel
          </button>
          <button
            onClick={onDelete}
            className="flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-white bg-red-500 rounded-xl hover:bg-red-600 active:scale-95 transition-all shadow-sm shadow-red-200"
          >
            <Trash2 size={15} />
            Delete {count > 1 ? `${count} Clients` : 'Client'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteClientModal;